"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _utils = require("../../../utils");
var _classnames = _interopRequireDefault(require("classnames"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var __assign = void 0 && (void 0).__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
function HeaderCard(props) {
  var _a = props.anchor,
    anchor = _a === void 0 ? [] : _a,
    _b = props.isTransform,
    isTransform = _b === void 0 ? true : _b,
    _c = props.inInBanner,
    inInBanner = _c === void 0 ? true : _c;
  var dataList = anchor;
  var navigatorRef = (0, _react.useRef)();
  return /*#__PURE__*/_react["default"].createElement("section", {
    ref: navigatorRef,
    className: (0, _classnames["default"])('student-center-header-container', {
      'is-transform': isTransform
    })
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])('student-center-header-container__div', {
      'is-in-banner': inInBanner
    })
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: 'student-center-header-ul student-center-header-ul--noFix'
  }, dataList.map(function (item, index) {
    var _a = item || {},
      href = _a.href,
      title = _a.title,
      imgUrl = _a.imgUrl,
      description = _a.description,
      extendProps = _a.extendProps;
    var _b = (0, _utils.fomateFileData)(imgUrl),
      url = _b.url,
      _c = _b.alt,
      alt = _c === void 0 ? '' : _c;
    return href ? ( /*#__PURE__*/_react["default"].createElement("a", __assign({
      className: (0, _classnames["default"])('student-center-header-ul__li student-center-header-ul__li--noFix', {
        'is-Href': href
      }),
      href: href,
      key: index
    }, extendProps || {}), /*#__PURE__*/_react["default"].createElement("span", {
      className: 'li-span li-span--noFix'
    }, /*#__PURE__*/_react["default"].createElement("img", {
      src: url,
      alt: alt
    }), /*#__PURE__*/_react["default"].createElement("span", {
      className: 'span-layout'
    }, /*#__PURE__*/_react["default"].createElement("span", {
      className: 'title'
    }, title), /*#__PURE__*/_react["default"].createElement("span", {
      className: 'desc'
    }, description))))) : ( /*#__PURE__*/_react["default"].createElement("div", __assign({
      className: (0, _classnames["default"])('student-center-header-ul__li student-center-header-ul__li--noFix', {
        'is-Href': href
      }),
      key: index
    }, extendProps || {}), /*#__PURE__*/_react["default"].createElement("span", {
      className: 'li-span li-span--noFix'
    }, /*#__PURE__*/_react["default"].createElement("img", {
      src: url,
      alt: alt
    }), /*#__PURE__*/_react["default"].createElement("span", {
      className: 'span-layout'
    }, /*#__PURE__*/_react["default"].createElement("span", {
      className: 'title'
    }, title), /*#__PURE__*/_react["default"].createElement("span", {
      className: 'desc'
    }, description)))));
  }))));
}
var _default = exports["default"] = HeaderCard;